import React from 'react';
import { Alert } from 'antd';

export default (args) => <Alert {...args} />;
